import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AppProvider } from './contexts/AppContext';
import { TabBar } from './components/layout/TabBar';
import { ProfileTab } from './components/layout/ProfileTab';
import { ModelsGrid } from './components/models/ModelCard';
import { EvaluateTab } from './components/layout/EvaluateTab';
import { DashboardTab } from './components/layout/DashboardTab';
import { ConfigTab } from './components/layout/ConfigTab';
import { Container, PageHeader } from './components/layout/Container';
function AppContent() {
    const [activeTab, setActiveTab] = useState('profile');
    return (_jsxs("div", { className: "min-h-screen bg-bg", children: [_jsx(TabBar, { activeTab: activeTab, onTabChange: setActiveTab }), _jsxs(Container, { children: [_jsx(PageHeader, { title: ['profile', 'models', 'evaluate', 'dashboard', 'config'].find(t => t === activeTab) ?
                            { profile: 'Meu Perfil', models: 'Modelos de Negócio', evaluate: 'Avaliação', dashboard: 'Dashboard', config: 'Configurações' }[activeTab]
                            : 'DecidePro' }), activeTab === 'profile' && _jsx(ProfileTab, {}), activeTab === 'models' && _jsx(ModelsGrid, {}), activeTab === 'evaluate' && _jsx(EvaluateTab, {}), activeTab === 'dashboard' && _jsx(DashboardTab, {}), activeTab === 'config' && _jsx(ConfigTab, {})] })] }));
}
export default function App() {
    return (_jsx(AppProvider, { children: _jsx(AppContent, {}) }));
}
